import React from 'react';

export default class TicketStubSidebar extends React.Component {
  static propTypes = {
    children: React.PropTypes.node
  };

  render () {
    return (
      <div className="ticket_stub_sidebar">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/side_bar.js